import { DatePicker as MuiDatePicker, DatePickerProps } from '@mui/x-date-pickers';
import { Moment } from 'moment';
import { FormControl, FormHelperText } from '@mui/material';

export const DatePicker = (props: DatePickerProps<Moment> & { helperText?: string | false, error?: boolean }) => {
    const { helperText, error, ...datePickerProps } = props;
    return (
        <FormControl error={error} fullWidth>
            <MuiDatePicker sx={{ width: '100%' }} {...datePickerProps} />
            {helperText && <FormHelperText>{helperText}</FormHelperText>}
        </FormControl>
    )
}